module.exports = __webpack_public_path__ + "img/Progress.53ea1f47.svg";